import styled from "styled-components";

export const Wrapper = styled.div`
  .data-table {
    padding: 50px 42px;

    &.extra-padding-top {
      padding-top: 75px;
    }

    @media print {
      padding: 40px 35px;
      padding-bottom: 0;
      &.extra-padding-top {
        padding-top: 65px;
      }
    }

    .work-setting-column {
      width: 224px;
      max-width: 224px;
    }

    .data-column {
      width: 74px;
      max-width: 74px;
    }

    .row {
      padding: 0;
      margin: 0 !important;
      width: 742px;
      max-width: 742px;

      &:first-child .column {
        height: 52px;
      }

      &:nth-child(even) {
        background: #fafafa;

        .column.selected {
          background: #e8f6fa;
        }
      }

      &:first-child .column {
        font-size: 11px;
        line-height: 1.18;
        color: #016e93;
        padding-left: 0;
        padding-right: 0;
        word-spacing: 100px;
        text-align: center;
        flex-direction: column;
      }

      &:nth-child(2) {
        background: #f3f3f3;
        font-size: 15px;
        color: #aeaebd;

        .column:first-child {
          color: #00c4ff;
          flex-direction: row-reverse;
        }

        .column.selected {
          background: #e2f0f4;
        }
      }

      .column:first-child {
        text-align: right;
        padding-left: 2px;
        color: #026d94;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .column {
        padding-right: 4px;
        padding-left: 29px;
        max-height: 45px;
        min-height: 45px;
        text-align: left;
        position: relative;
        display: flex;
        align-items: center;

        &.selected {
          background: #edfbff;
        }

      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/DataTable/style.js